module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/CPU2-f5c5f49d174d3c870451724af9186105.svg";